module.exports = __webpack_public_path__ + "img/icon_ipo_suggestion_3@3x.d5899e15.png";